import React, {useCallback} from "react";
import {useDispatch} from "react-redux";
import * as ReactBootstrap from "react-bootstrap";
import {Confirm, ICONS} from "../../../components";
import {showErrorToast, showSuccessToast} from "../../../state/toasts";
import {QuotationRecordService} from "../../../services";
import {AxiosResponse} from "axios";
import {QuotationRecord} from "../../../api";

export type EstimationLineDeleteButtonProps = {
    record: QuotationRecord;
    onDelete?: (response: AxiosResponse) => void;
};

export const EstimationLineDeleteButton = ({
    record,
    onDelete,
}: EstimationLineDeleteButtonProps): JSX.Element => {
    const dispatch = useDispatch();

    const onConfirmDelete = useCallback(() => {
        if (!record?.url) {
            dispatch(showErrorToast('Error', 'Invalid record URL'));
            return;
        }

        new QuotationRecordService(record.url)
            .makeDeleteRequest()
            .then((response) => {
                onDelete?.(response);
                dispatch(
                    showSuccessToast('Success', 'Estimation Line deleted successfully')
                );
            })
            .catch((errors) => {
                dispatch(
                    showErrorToast(
                        'Error',
                        errors?.response?.data || 'Something went wrong'
                    )
                );
            });
    }, [record?.url, onDelete, dispatch]);

    return (
        <Confirm
            onConfirm={onConfirmDelete}
            body="Are you sure you want to delete this Estimation Line?"
            confirmText="Confirm delete item"
            confirmBSStyle="danger"
            title="Confirm delete Estimation Line"
        >
            <ReactBootstrap.Button
                disabled={!!record.is_deleted}
                variant="danger"
            >
                {ICONS.DELETE}
            </ReactBootstrap.Button>
        </Confirm>
    );
};
